export default "__VITE_ASSET__Ci87TACM__"